module.exports = __webpack_public_path__ + "6ca0253cd9b16fcb5dcf9e7f7ca6c1ef.woff";


//////////////////
// WEBPACK FOOTER
// ./src/shared/fontello/font/fontello.woff
// module id = 1120
// module chunks = 15 16 17 18 19